import React from "react";
import { normalizeCompany } from "../utils/companyUtils";

export default function PovinnostiForm({
  formText,
  setFormText,
  setAutocompleteText,
  uniqueTaskTemplatesFiltered = [],
  showTaskSuggestions,
  setShowTaskSuggestions,
  povinnostInputRef,
  company,
  setCompany,
  deadline,
  setDeadline,
  deadlineTime,
  setDeadlineTime,
  repeatInterval,
  setRepeatInterval,
  estimatedTime,
  setEstimatedTime,
  subtasksInput,
  setSubtasksInput,
  formFiles,
  setFormFiles,
  companyList = [],
  addToCompanyList,
  taskList = [],
  addToTaskList,
  handleAddTasks
}) {
  // Spoločný štýl pre všetky inputy, aby boli v jednej rovine
  const commonInputStyle = {
    height: '36px',
    padding: '4px 10px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
    background: 'white'
  };

  const handleCompanyBlur = () => {
    if (company) setCompany(normalizeCompany(company));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const normalized = normalizeCompany(company);
    if (normalized && !companyList.includes(normalized)) {
      const ok = window.confirm(`Firma "${normalized}" nie je v zozname. Pridať ju?`);
      if (!ok) return;
      if (addToCompanyList) addToCompanyList(normalized);
    }
    if (normalized) setCompany(normalized);

    const taskNames = formText.split(',').map(t => t.trim()).filter(Boolean);
    for (const name of taskNames) {
      if (name && !taskList.includes(name)) {
        const ok = window.confirm(`Povinnosť "${name}" nie je v zozname. Pridať ju?`);
        if (!ok) return;
        if (addToTaskList) addToTaskList(name);
      }
    }

    handleAddTasks(e);
  };

  return (
    <form onSubmit={handleSubmit} style={{ 
      maxWidth: "1350px", 
      margin: "0.5rem auto", 
      background: "rgba(255,255,255,0.1)", 
      borderRadius: 10, 
      padding: '10px 15px', 
      boxShadow: "0 2px 16px rgba(0,0,0,0.1)" 
    }}>
      <div style={{ 
        display: "flex", 
        gap: 10, 
        alignItems: "center", // Toto ich zarovná do jednej výškovej línie
        flexWrap: "nowrap" // Držíme to v jednom riadku
      }}>
        
        {/* Názov povinnosti */}
        <div style={{ position: 'relative', flex: 3, minWidth: 200 }}>
          <input
            type="text"
            list="task-list-form"
            value={formText}
            onChange={e => {
              setFormText(e.target.value);
              setAutocompleteText(e.target.value);
            }}
            placeholder="Povinnosť..."
            style={{ ...commonInputStyle, width: '100%' }}
            required
            ref={povinnostInputRef}
            autoComplete="off"
            onFocus={() => setShowTaskSuggestions(true)}
            onBlur={() => setTimeout(() => setShowTaskSuggestions(false), 150)}
          />
          <datalist id="task-list-form">
            {taskList.map(t => <option key={t} value={t} />)}
          </datalist>
          {showTaskSuggestions && (
            <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                background: 'white',
                border: '1px solid #ccc',
                borderRadius: 6,
                zIndex: 100,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                fontSize: 14,
                maxHeight: 250,
                overflowY: 'auto',
                marginTop: '5px'
            }}>
              <div
                onClick={() => {
                  setFormText('prihlasenie zamestnanca');
                  setAutocompleteText('prihlasenie zamestnanca');
                  setSubtasksInput('dotazník vyplnený\nprihlásenie SP\nprihlásenie ZP\npracovná zmluva\nvyhlásenie k dani\nvyhlásenie OOP socpoist');
                  setShowTaskSuggestions(false);
                }}
                style={{ padding: '8px 12px', cursor: 'pointer', color: '#1976D2', fontWeight: 'bold' }}
              >
                ➕ prihlasenie zamestnanca (šablóna)
              </div>
              {uniqueTaskTemplatesFiltered.map((tpl, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    setFormText(tpl.text);
                    setAutocompleteText(tpl.text);
                    setSubtasksInput(tpl.subtasks || '');
                    setShowTaskSuggestions(false);
                  }}
                  style={{ padding: '8px 12px', borderTop: '1px solid #f0f0f0', cursor: 'pointer' }}
                >
                  {tpl.text}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Firma */}
        <input
          type="text"
          list="company-list-form"
          value={company}
          onChange={e => setCompany(e.target.value.toUpperCase())}
          onBlur={handleCompanyBlur}
          placeholder="Firma..."
          style={{ ...commonInputStyle, flex: "1.5", minWidth: 130 }}
        />
        <datalist id="company-list-form">
          {companyList.map(c => <option key={c} value={c} />)}
        </datalist>

        {/* Termín */}
        <input
          type="date"
          value={deadline}
          onChange={e => setDeadline(e.target.value)}
          style={{ ...commonInputStyle, width: "135px" }}
          required
        />

        {/* Čas termínu (voliteľný) */}
        <input
          type="time"
          value={deadlineTime || ""}
          onChange={e => setDeadlineTime && setDeadlineTime(e.target.value)}
          title="Čas termínu (voliteľné)"
          style={{ ...commonInputStyle, width: "100px" }}
        />

        {/* Interval */}
        <select
          value={repeatInterval}
          onChange={e => setRepeatInterval(e.target.value)}
          style={{ ...commonInputStyle, width: "110px" }}
        >
          <option value="none">Bez opakovania</option>
          <option value="weekly">Týždenne</option>
          <option value="monthly">Mesačne</option>
          <option value="quarterly">Štvrťročne</option>
          <option value="annually">Ročne</option>
        </select>

        {/* Čas */}
        <input
          type="number"
          value={estimatedTime}
          onChange={e => setEstimatedTime(e.target.value)}
          placeholder="Min"
          style={{ ...commonInputStyle, width: "65px" }}
          required
        />

        {/* Podúlohy - premenené na input pre zachovanie výšky */}
        <input
          type="text"
          value={subtasksInput}
          onChange={e => setSubtasksInput(e.target.value)}
          placeholder="Podúlohy..."
          style={{ ...commonInputStyle, flex: "1.5", minWidth: 130 }}
        />

        {/* Príloha */}
        <label style={{ 
          cursor: 'pointer', 
          padding: '0 12px', 
          background: '#eceff1', 
          color: '#455a64', 
          borderRadius: '6px', 
          fontSize: '13px', 
          height: '36px', 
          display: 'flex', 
          alignItems: 'center',
          border: '1px solid #cfd8dc',
          whiteSpace: 'nowrap'
        }}>
          📎 {formFiles.length > 0 ? `${formFiles.length} súb.` : 'Súbory'}
          <input
            type="file"
            multiple
            style={{ display: 'none' }}
            onChange={(e) => {
              const files = Array.from(e.target.files);
              setFormFiles(prev => [...prev, ...files]);
              e.target.value = '';
            }}
          />
        </label>

        {/* Tlačidlo PRIDAŤ */}
        <button type="submit" style={{ 
          padding: "0 20px", 
          borderRadius: 6, 
          fontSize: 14, 
          fontWeight: 'bold',
          height: '36px', 
          background: '#2e7d32', 
          color: 'white', 
          border: 'none', 
          cursor: 'pointer',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          PRIDAŤ
        </button>
      </div>
    </form>
  );
}